var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCert(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 120.01,
    height: 106.717,
    viewBox: "0 0 120.01 106.717",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-0.445)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M96.54,2.435H94.724V.609a.606.606,0,1,0-1.211,0V2.435H91.7a.653.653,0,0,0-.606.609.653.653,0,0,0,.606.609h1.817V5.478a.606.606,0,1,0,1.211,0V3.652H96.54a.653.653,0,0,0,.605-.609A.653.653,0,0,0,96.54,2.435Z",
    fill: "#ffb5d7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.176,92.928H11.36V91.1a.606.606,0,1,0-1.211,0v1.826H8.231a.609.609,0,0,0,0,1.217h1.817v1.826a.606.606,0,1,0,1.211,0V94.145h1.817a.653.653,0,0,0,.606-.609A.507.507,0,0,0,13.176,92.928Z",
    fill: "#ccdcff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.972,10.665A1.724,1.724,0,1,0,19.81,9.558,1.726,1.726,0,0,0,21.972,10.665Z",
    fill: "#e2ebff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.692,68.075A1.724,1.724,0,1,0,.53,66.968,1.726,1.726,0,0,0,2.692,68.075Z",
    fill: "#e2ebff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M112.562,37.908a3.869,3.869,0,0,0,.244-5.446,3.821,3.821,0,0,0-5.418-.245,3.869,3.869,0,0,0-.244,5.446A3.821,3.821,0,0,0,112.562,37.908Z",
    fill: "#e2ebff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M112.777,20.694a1.63,1.63,0,0,0,.1-2.293,1.61,1.61,0,0,0-2.282-.1,1.629,1.629,0,0,0-.1,2.293A1.608,1.608,0,0,0,112.777,20.694Z",
    fill: "#ea67a4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M92.4,16.536H27.508v89.58H92.4Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.508,82.174V16.536H40.729",
    fill: "none",
    stroke: "#182052",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52.84,16.536H92.4v89.681H27.508v-4.463",
    fill: "none",
    stroke: "#182052",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.573,16.536h1.009",
    fill: "none",
    stroke: "#182052",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.086,42.3a.812.812,0,0,1,0-1.623H83.824a.812.812,0,0,1,0,1.623Z",
    fill: "#dfe9ff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.086,48.391a.812.812,0,0,1,0-1.623H83.824a.812.812,0,0,1,0,1.623Z",
    fill: "#dfe9ff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.086,54.478a.812.812,0,0,1,0-1.623H83.824a.812.812,0,0,1,0,1.623Z",
    fill: "#dfe9ff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.086,60.565a.812.812,0,0,1,0-1.623H83.824a.812.812,0,0,1,0,1.623Z",
    fill: "#dfe9ff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.086,66.754a.812.812,0,0,1,0-1.623H83.824a.812.812,0,0,1,0,1.623Z",
    fill: "#dfe9ff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.086,72.841a.812.812,0,0,1,0-1.623H57.079a.812.812,0,0,1,0,1.623Z",
    fill: "#dfe9ff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M71.107,26.986H48.8a.913.913,0,0,1,0-1.826h22.3a.913.913,0,0,1,0,1.826Z",
    fill: "#dfe9ff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M65.456,31.754h-11a.913.913,0,0,1,0-1.826h11a.913.913,0,0,1,0,1.826Z",
    fill: "#dfe9ff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M79.989,91.406c-.2-1.42-.3-2.435-1.312-2.739-1.615-.406-2.119,1.725-3.633,3.348a11.905,11.905,0,0,1-1.817,1.319c-.2.1-.606.3-.706-.1-.4-1.217,0-.609,1.716-2.536a4.023,4.023,0,0,0,1.11-3.348,2.207,2.207,0,0,0-1.413-1.826,1.866,1.866,0,0,0-2.22.507C70.3,87.754,70.7,88.768,70.6,91.3a.558.558,0,0,1-.3.507,11.95,11.95,0,0,1-4.642,1.522v-.1a13.245,13.245,0,0,0,3.129-7,6.27,6.27,0,0,0-.5-4.058c-1.312-2.435-4.844-2.131-6.459.811C60.207,86.131,60.51,91,62.73,93.739a13.572,13.572,0,0,1-1.413,1.116.789.789,0,0,0-.2,1.014.822.822,0,0,0,1.211.2c1.615-1.319,1.514-1.217,1.716-1.319a2.728,2.728,0,0,1,.908,0,18.448,18.448,0,0,0,2.624-.2c.4-.1,3.129-1.116,3.23-1.116a.315.315,0,0,0,.1.2,1.714,1.714,0,0,0,2.119,1.42,4.45,4.45,0,0,0,2.422-1.116c.807-.812,2.119-2.435,2.826-3.348.2.71.2,1.319.4,1.928a1.213,1.213,0,0,0,2.22.406c.807-.913,1.11-2.131,2.018-2.638a.763.763,0,0,0,.5-.71.785.785,0,0,0-1.11-.71A5.646,5.646,0,0,0,79.989,91.406Zm-15.946,1.42a6.877,6.877,0,0,1-1.312-3.348,8.929,8.929,0,0,1,.5-5.377,2.682,2.682,0,0,1,1.918-1.826c1.009-.2,1.716,0,1.917,1.015C67.878,86.739,66.465,90.087,64.043,92.826Zm8.478-5.275c.605-1.217,1.312-.1,1.211.406a8.107,8.107,0,0,1-.807,1.623,5.074,5.074,0,0,1-.706.811A5.173,5.173,0,0,1,72.52,87.551Z",
    fill: "#84a2ff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M112.386,52.957a30.275,30.275,0,0,1,6.762,1.014c1.009.3,1.009.406.4,1.319-1.413,2.029-2.826,3.956-4.037,6.087-1.715,2.841-2.624,2.029-6.964,3.348l3.836.913c.1,0,.1,0,.2.1a.5.5,0,0,1,.1.71l-1.816,2.739A30.366,30.366,0,0,1,92.2,80.855a3.292,3.292,0,0,0-2.321,1.826c-.908,1.826-1.716,3.652-2.624,5.478a1.13,1.13,0,1,1-2.019-1.015c.5-1.116,1.009-2.232,1.514-3.246a3.673,3.673,0,0,0,0-2.739,20.7,20.7,0,0,1-1.009-4.971,21.1,21.1,0,0,1,.706-4.971,24.281,24.281,0,0,1,3.23-7.406l.1-.1c.1,0,.3,0,.3.2a8.542,8.542,0,0,0,.4,1.217,19.39,19.39,0,0,1,.908-2.942,3.8,3.8,0,0,1,.706-1.217,24.3,24.3,0,0,1,5.45-4.159h.1a.218.218,0,0,1,.2.2v1.928a28.239,28.239,0,0,1,2.725-3.348,2.613,2.613,0,0,1,1.111-.71,19.981,19.981,0,0,1,4.037-1.116",
    fill: "#84a2ff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M85.842,77.3c0-.406-.1-.812-.1-1.116a21.1,21.1,0,0,1,.706-4.971,24.283,24.283,0,0,1,3.23-7.406l.1-.1c.1,0,.3,0,.3.2a8.538,8.538,0,0,0,.4,1.217,19.393,19.393,0,0,1,.908-2.942,3.8,3.8,0,0,1,.707-1.217,24.292,24.292,0,0,1,5.45-4.159h.1a.218.218,0,0,1,.2.2v1.928a28.2,28.2,0,0,1,2.725-3.348,2.616,2.616,0,0,1,1.11-.71,36.173,36.173,0,0,1,4.441-1.217",
    fill: "none",
    stroke: "#182052",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M113.5,52.957a26.437,26.437,0,0,1,5.652,1.014c1.009.3,1.009.406.4,1.319-1.413,2.029-2.826,3.956-4.037,6.087-1.715,2.841-2.624,2.029-6.964,3.348l3.836.913c.1,0,.1,0,.2.1a.5.5,0,0,1,.1.71l-1.816,2.739A30.366,30.366,0,0,1,92.2,80.855a3.292,3.292,0,0,0-2.321,1.826c-.908,1.826-1.716,3.652-2.624,5.478a1.13,1.13,0,1,1-2.019-1.015c.5-1.116,1.009-2.232,1.514-3.246a3.673,3.673,0,0,0,0-2.739c-.1-.2-.1-.406-.2-.609",
    fill: "none",
    stroke: "#182052",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M108.954,53.057h.4",
    fill: "none",
    stroke: "#182052",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M101.385,64.015c-6.762,4.971-11,12.174-14.634,19.884",
    fill: "none",
    stroke: "#182052",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M109.055,59.855a40.087,40.087,0,0,0-5.147,2.435",
    fill: "none",
    stroke: "#182052",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.4,95.515a1.925,1.925,0,0,1-2.523.507A4.433,4.433,0,0,0,39.458,94.8c-1.009-.1-1.918-.2-2.22-1.319a2.245,2.245,0,0,1-.1-.812,4.093,4.093,0,0,0-.908-2.029c-.707-.812-1.211-1.522-.707-2.435.606-1.014,1.211-1.42,1.211-2.638a3.144,3.144,0,0,1,.1-1.015,1.825,1.825,0,0,1,1.716-1.42c.3,0,.605-.1.908-.1,1.009-.1,1.312-.812,2.624-1.319a1.293,1.293,0,0,1,1.211.1c.3.2.605.406,1.009.71.908.71,1.514.406,2.826.812a1.538,1.538,0,0,1,1.009,1.217,5.361,5.361,0,0,0,.4,1.826c.5,1.014,1.514,1.522,1.413,2.638a1.092,1.092,0,0,1-.2.609,7.883,7.883,0,0,0-1.211,2.232,2.243,2.243,0,0,0-.1.812,1.706,1.706,0,0,1-.605,1.42C46.624,95.21,45.514,94.4,44.4,95.515Zm-6.257-3.652a5.133,5.133,0,0,0,7.065,1.42,4.946,4.946,0,0,0,1.514-6.8.1.1,0,0,0-.1-.1,5.133,5.133,0,0,0-7.065-1.42,4.946,4.946,0,0,0-1.514,6.8C38.146,91.761,38.146,91.761,38.146,91.862Z",
    fill: "#dfe9ff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.064,85.573a4.275,4.275,0,0,1,5.955,1.217,4.1,4.1,0,0,1-1.009,5.681l-.1.1a4.366,4.366,0,0,1-5.955-1.217,4.1,4.1,0,0,1,1.009-5.681Z",
    fill: "#dfe9ff"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCert);
export default __webpack_public_path__ + "static/media/cert.42149e6bccb88026f0b1231c058e9719.svg";
export { ForwardRef as ReactComponent };